import React from 'react';
import './services.css';
import Checked from '../../assets/images/services/checked.svg';
import { formatDuration } from '../../helpers/constants';

const SingleService = ({
    selectedServices,
    handleSelectedServices,
    item,
    handleAddOnSelect,
}) => {
    const selectedService = selectedServices.find((s) => s.id === item.id);
    const selectedAddOns = selectedService?.selectedAddOns || [];

    return (
        <div>
            <div
                className={`single-service-card w-100 mt-3 cp ${
                    selectedService ? 'active' : ''
                }`}
                onClick={(e) => {
                    if (e.target.closest('.addon-pill')) return;
                    handleSelectedServices(item);
                }}
            >
                <div className="d-flex align-items-center justify-content-between">
                    <div className="flex-grow-1 pe-3 text-wrap">
                        <div className="d-flex align-items-sm-center align-items-start flex-sm-row flex-column gap-sm-2 gap-1 mb-2">
                            <p className="m-0 fw-semibold c-0f151d poppins f-18">
                                {item?.name}
                            </p>
                            <div className="d-flex align-items-center">
                                <div className="service-dot d-sm-block d-none mx-1"></div>
                                <p className="m-0 c-667085 f-15 poppins">
                                    {formatDuration(item?.duration)}
                                </p>
                            </div>
                        </div>
                        <p
                            className="m-0 c-667085 f-15 poppins fw-light mb-2"
                            dangerouslySetInnerHTML={{
                                __html: item?.description || '',
                            }}
                        />
                        <p className="m-0 fw-semibold  poppins f-16 c-101828">
                            £{item?.price}
                        </p>

                        {item?.addOns?.length > 0 && (
                            <h2 className="fs-6 mt-3 mb-2">+ Available Add-Ons</h2>
                        )}
                        <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                            {item?.addOns?.map((adon) => {
                                const isSelected = selectedAddOns.some(
                                    (a) => a.id === adon.id
                                );

                                return (
                                    <div
                                        onClick={() =>
                                            handleAddOnSelect(item, adon)
                                        }
                                        className={`addon-pill cp d-flex align-items-center poppins f-14 ${
                                            isSelected ? 'active' : ''
                                        }`}
                                    >
                                        {adon?.name} (£{adon?.price}) -{' '}
                                        {formatDuration(adon?.duration)}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="flex-shrink-0 d-flex align-items-center">
                        <div
                            className={`custom-checkbox ${
                                selectedService
                                    ? 'custom-checkbox-active'
                                    : ''
                            }`}
                        >
                            <img
                                src={Checked}
                                className={
                                    selectedService
                                        ? 'check-icon-active'
                                        : 'check-icon-inactive'
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleService;
